import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NavigationContext, SessionContext } from 'src/app/core/services/config/app.settings';
import { DeclarationRevendication } from 'src/app/data/declaration/models/declaration-revendication.model';
import { DeclarationsService } from 'src/app/data/declaration/services/declarations/declarations.service';
import { SaisieVciComponent } from '../affichage-drev/modals/saisie-vci/saisie-vci.component';

@Component({
    selector: 'app-registre-vci',
    templateUrl: './registre-vci.component.html',
    styleUrls: ['./registre-vci.component.scss'],
    standalone: false
})
export class RegistreVciComponent implements OnInit {
    get idIntervenant(): number {
        if (NavigationContext.has('idOperateur')) {
            return NavigationContext.get('idOperateur');
        } else {
            return SessionContext.get('idIntervenant');
        }
    }

    declarations: DeclarationRevendication[];

    filters = {
        millesime: '',
        annee: '',
        produit: ''
    };

    columns = [
        { field: 'millesime', label: 'Millésime', visible: true },
        { field: 'annee', label: 'Année revendication', visible: true },
        { field: 'produit', label: 'Produit (Mention valorisante)', visible: true },
        { field: 'surface', label: 'Surface (ha)', visible: false },
        { field: 'vciStock', label: 'Vci en stock pour le millésime', visible: true },
        { field: 'vciRevendique', label: 'VCI revendiqué', visible: true },
        { field: 'vciRemplacement', label: 'VCI en remplacement', visible: false },
        { field: 'vciSubstitution', label: 'VCI en substitution qualitative', visible: false },
        { field: 'vciComplement', label: 'VCI en complément de récolte', visible: false },
        { field: 'vciDetruit', label: 'VCI détruit', visible: true },
        { field: 'vciNouveau', label: 'VCI nouveau', visible: false },
        { field: 'soldeVCI', label: 'Solde VCI du millésime', visible: true }
    ];

    @ViewChild('columnModal', { static: true }) columnModal: any;

    readonly STORAGE_KEY = 'registre_vci_columns_visibility';

    filteredDrevAOCs: DeclarationRevendication[] = [];

    constructor(private readonly modalService: NgbModal, private readonly declarationsService: DeclarationsService) {}

    ngOnInit() {
        this.loadColumnVisibility();
        if (NavigationContext.get('idOperateur') !== undefined) {
          this.loadData();
        }
    }

    loadData() {
        this.declarationsService.getConsultationDrevVCI(this.idIntervenant).subscribe((drev) => {

        this.declarations = drev.aocs.sort((a, b) => {
                const anneeA = a.campagne?.annee ?? 0;
                const anneeB = b.campagne?.annee ?? 0;

                if (anneeA !== anneeB) {
                return anneeB - anneeA;
                }

                const libelleA = a.produit?.libelle ?? '';
                const libelleB = b.produit?.libelle ?? '';

                return libelleA.localeCompare(libelleB, 'fr', { sensitivity: 'base' });
            });
            this.filteredDrevAOCs = this.declarations;
        });
    }

    applyFilters() {
        this.filteredDrevAOCs = this.declarations.filter(dec => {
            if (this.isColumnVisible('millesime') && this.getFilterString(this.filters.millesime, (dec.campagne.annee - 1).toString())) {
                return false;
            }
            if (this.isColumnVisible('annee') && this.getFilterString(this.filters.annee, dec.campagne.annee.toString())) {
                return false;
            }
            return !(this.isColumnVisible('produit') && this.getFilterString(this.filters.produit, dec.produit.libelle));
        });
    }

    getFilterString(filter: string, item: string) {
        return filter && ((item && item.toLowerCase().indexOf(filter.toLowerCase()) === -1) || item === undefined || item === '');
    }

    isColumnVisible(field: string): boolean {
        const column = this.columns.find(c => c.field === field);
        return column ? column.visible : false;
    }

    toggleColumnVisibility(field: string): void {
        const col = this.columns.find(c => c.field === field);
        if (col) {
            col.visible = !col.visible;
            this.saveColumnVisibility();
        }
    }

    saveColumnVisibility(): void {
        const visibility = this.columns.map(col => ({ field: col.field, visible: col.visible }));
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(visibility));
    }

    loadColumnVisibility(): void {
        const saved = localStorage.getItem(this.STORAGE_KEY);
        if (saved) {
            const parsed = JSON.parse(saved);
            for (const col of this.columns) {
                const savedCol = parsed.find((c: any) => c.field === col.field);
                if (savedCol) {
                    col.visible = savedCol.visible;
                }
            }
        }
    }

    getVisibleColumnCount(): number {
        return this.columns.filter(col => col.visible).length;
    }

    openColumnModal() {
        this.modalService.open(this.columnModal, { centered: true });
    }

    utilisationVci(declaration: DeclarationRevendication) {
        const modal = this.modalService.open(SaisieVciComponent, { backdrop: 'static', size: 'xl' as any });
        (modal.componentInstance as SaisieVciComponent).campagne = declaration.campagne.annee;
        (modal.componentInstance as SaisieVciComponent).drev = declaration;
        (modal.componentInstance as SaisieVciComponent).saisie = declaration.drevSaisie;
        (modal.componentInstance as SaisieVciComponent).creation = false;

        modal.result.then();
    }
}
